export enum BaseUrl {
  Claim,
  File,
  Login,
  Request,
  Afd,
  Content
}
